import { string } from 'yup';

export type Email = string;

const emailRegexp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const requiredErrorMessage = 'Este campo es obligatorio.';
export const invalidErrorMessage =
  'Ingresa el correo en formato cajin@correo.cl';

export const emailYupValidation = string()
  .required(requiredErrorMessage)
  .matches(emailRegexp, invalidErrorMessage);
